export default "__VITE_ASSET__BFPtOoVc__"